import { RouterModule, Routes } from '@angular/router';

import { AddPointOpenInspectionPageComponent } from '../pages/addPoint/open-inspection.component';
import { AddPointOpenSectionPageComponent } from '../pages/addPoint/open-section.component';
import { AddPointPageComponent } from '../pages/addPoint/add-point.component';
import { InspectionResolver } from '../../utils/inspection.resolver';
import { NgModule } from '@angular/core';
import { SectionDetailPageComponent } from '../pages/detail.component';
import { SectionEditJsonPageComponent } from '../pages/edit-json.component';
import { SectionEditPageComponent } from '../pages/edit.component';
import { SynchronizationResolver } from '../../utils/syncronization.resolver';
import { PermissionGuard } from '../../utils/permission.guard';
import { environment } from '../../../environments/environment';

const appRoute = environment.applicationRoute;

const routes: Routes = [
  {
    path: '',
    resolve: { synchronizeData: SynchronizationResolver, inspection: InspectionResolver },
    children: [
      { path: appRoute + '/inspections/:inspectionId/sections/:sectionId/addpoint', component: AddPointPageComponent },
      {
        path: appRoute + '/inspections/:inspectionId/sections/:sectionId/addpoint/:targetInspectionId',
        component: AddPointOpenInspectionPageComponent
      },
      {
        path: appRoute + '/inspections/:inspectionId/sections/:sectionId/addpoint/:targetInspectionId/:targetSectionId',
        component: AddPointOpenSectionPageComponent
      },
      {
        path: appRoute + '/inspections/:inspectionId/sections/:sectionId/folders/:folderId',
        component: SectionDetailPageComponent
      },
      { path: appRoute + '/inspections/:inspectionId/sections/:sectionId/edit', component: SectionEditPageComponent },
      {
        path: appRoute + '/inspections/:inspectionId/sections/:sectionId/editjson',
        component: SectionEditJsonPageComponent
      }
    ]
  },
  {
    path: '',
    resolve: { inspection: InspectionResolver },
    children: [
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/folders/:folderId',
        component: SectionDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/edit',
        component: SectionEditPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: appRoute + '/templates/:inspectionId/sections/:sectionId/editjson',
        component: SectionEditJsonPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SectionEditorRoutingModule {}
export const routedComponents = [
  AddPointPageComponent,
  AddPointOpenInspectionPageComponent,
  AddPointOpenSectionPageComponent,
  SectionEditPageComponent,
  SectionEditJsonPageComponent
];
